import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { AuditlogState } from './auditlog.state';
import { getters } from './auditlog.getters';
import { mutations } from './auditlog.mutations';
import { actions } from './auditlog.actions';

VueXHelper.setStoreModule(Module.AUDITLOG, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new AuditlogState(),
  getters,
  mutations,
  actions,
};
